<div class="icon">🥳</div>
@if (continueUrl) {
  <div class="fs-24 fw-bold mt-20 main-color" i18n="@@youreAllSet">You're all set!</div>
  <div class="subtitle mt-20" i18n="@@thankYouKeepListening">
    Thank you! Your subscription is active — pick up right where you left off.
  </div>
  <div class="store-buttons mt-24 w-100">
    <a mat-flat-button class="tagus w-100 store-button" [routerLink]="continueUrl"
      ><ng-container i18n="@@continueInPeech">Continue in Peech</ng-container></a
    >
  </div>
  <div class="message mt-20" i18n="@@downloadAppOptional">
    Prefer to listen on the go? Get the mobile app — you're already signed in.
  </div>
} @else {
  <div class="fs-24 fw-bold mt-20 main-color" i18n="@@justOneMoreStep">Just one more step!</div>
  <div class="subtitle mt-20" i18n="@@thankYouDownloadApp">
    Thank you! It's time to download the app!
  </div>
  <div class="message mt-20" i18n="@@downloadAppInstructions">
    Use the button below to download the Peech app. If you are not signed in automatically, please
    make sure to Sign In with your email so your profile is synced. Enjoy!
  </div>
}
<div class="store-buttons mt-24 w-100">
  @if (showIosButton) {
    <a
      mat-flat-button
      class="w-100 store-button"
      [class.tagus]="!continueUrl"
      [class.store-button-secondary]="continueUrl"
      [href]="iosUrl"
      ><span class="store-button-content"
        ><i class="ri-app-store-line"></i>
        <ng-container i18n="@@downloadPeechIos">Download on the App Store</ng-container></span
      ></a
    >
  }
  @if (showAndroidButton) {
    <a
      mat-flat-button
      class="w-100 store-button"
      [class.tagus]="!continueUrl"
      [class.store-button-secondary]="continueUrl"
      [href]="androidUrl"
      ><span class="store-button-content">
        <svg class="store-glyph" viewBox="-1 0 24 24" fill="currentColor" aria-hidden="true">
          <path
            d="m3.751.61 13.124 7.546-2.813 2.813zm-2.719-.61 12.047 12-12.046 12c-.613-.271-1.033-.874-1.033-1.575 0-.023 0-.046.001-.068v.003-20.719c-.001-.019-.001-.042-.001-.065 0-.701.42-1.304 1.022-1.571l.011-.004zm19.922 10.594c.414.307.679.795.679 1.344 0 .022 0 .043-.001.065v-.003c.004.043.007.094.007.145 0 .516-.25.974-.636 1.258l-.004.003-2.813 1.593-3.046-2.999 3.047-3.047zm-17.203 12.796 10.312-10.359 2.813 2.813z"
          />
        </svg>
        <ng-container i18n="@@downloadPeechAndroid">Get it on Google Play</ng-container></span
      ></a
    >
  }
</div>
